const APP_THEME = process.env.REACT_APP_THEME || 'main'
const APP_CHANNEL = process.env.REACT_APP_CHANNEL || 'birdietime'
const APP_TEXT_SOURCE = process.env.REACT_APP_TEXT_SRC || 'birdietime'
const APP_VARIANT = process.env.REACT_APP_VARIANT || 'birdietime'

const GetCorrectEnvPkKey = () => {
  if (['production', 'ie'].includes(process.env.REACT_APP_NODE_ENV)) {
    return 'pk_live_eqNq6FHN4xh372Z2WC615UKm';
  } else {
    return 'pk_test_1B1uv0AHwdfxE4HAn2yWWVgH';
  }
}


export {
  APP_THEME,
  APP_CHANNEL,
  APP_TEXT_SOURCE,
  APP_VARIANT,
  GetCorrectEnvPkKey
}



// WEBPACK FOOTER //
// ./src/config.js